import type DeeplinkBootstrapState from './schema/DeeplinkBootstrapState';
import { createStore } from 'satcheljs';

const defaultDeeplinkBootstrapStore: DeeplinkBootstrapState = { displayedView: null };

const getStore = createStore<DeeplinkBootstrapState>(
    'deeplinkBootstrapStore',
    defaultDeeplinkBootstrapStore
);

export default getStore;
